import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0b0e13] border-t border-gold/20 text-gray-300 pt-16 pb-12 px-6">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
        {/* Columna Marca */}
        <div className="space-y-4">
          <Link to="/" className="inline-block">
            <span className="text-2xl font-black text-white tracking-wider">
              MATI<span className="text-gold-gradient">MARKET</span>
            </span>
          </Link>
          <p className="text-xs text-gray-400 leading-relaxed max-w-xs">
            Marketplace de productos premium, tiendas oficiales verificadas, sorteos y gamificación con MatiCoins.
          </p>
          <div className="pt-2">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full badge-official text-[10px] font-bold uppercase tracking-wider">
              <span className="w-1.5 h-1.5 rounded-full bg-amber-400 animate-pulse"></span>
              Plataforma 100% Segura
            </span>
          </div>
        </div>

        {/* Columna Tienda & Juegos */}
        <div className="space-y-3">
          <h4 className="text-xs font-bold uppercase tracking-widest text-gold">Juegos & Tienda</h4>
          <ul className="space-y-2 text-xs">
            <li>
              <Link to="/juegos/el-montoncito" className="hover:text-emerald-400 transition flex items-center gap-1.5 text-gray-300">
                <span>🎮</span> El Montoncito (Juego en Vivo)
              </Link>
            </li>
            <li>
              <Link to="/productos" className="hover:text-gold transition">
                Catálogo General de Productos
              </Link>
            </li>
            <li>
              <Link to="/comprar-tickets" className="hover:text-gold transition">
                Tickets para Sorteos
              </Link>
            </li>
          </ul>
        </div>

        {/* Columna Usuario & Ayuda */}
        <div className="space-y-3">
          <h4 className="text-xs font-bold uppercase tracking-widest text-gold">Tu Cuenta</h4>
          <ul className="space-y-2 text-xs">
            <li>
              <Link to="/ingresar" className="hover:text-gold transition">
                Iniciar Sesión
              </Link>
            </li>
            <li>
              <Link to="/registrate" className="hover:text-gold transition">
                Crear Cuenta Gratis
              </Link>
            </li>
            <li>
              <Link to="/recuperar-contrasena" className="hover:text-gold transition">
                Recuperar Contraseña
              </Link>
            </li>
            <li>
              <Link to="/como-participar" className="hover:text-gold transition">
                ¿Cómo Participar y Ganar?
              </Link>
            </li>
          </ul>
        </div>

        {/* Columna Legal & Soporte */}
        <div className="space-y-3">
          <h4 className="text-xs font-bold uppercase tracking-widest text-gold">Legal y Confianza</h4>
          <ul className="space-y-2 text-xs">
            <li>
              <Link to="/legal/terminos-y-condiciones" className="hover:text-gold transition">
                Términos y Condiciones
              </Link>
            </li>
            <li>
              <Link to="/legal/politica-de-privacidad" className="hover:text-gold transition">
                Políticas de Privacidad
              </Link>
            </li>
            <li className="pt-2 text-[11px] text-gray-400">
              ¿Dudas o soporte? Escríbenos a: <br />
              <span className="text-white font-medium">contacto@matimarket.com</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto pt-8 border-t border-gray-800/80 flex flex-col md:flex-row items-center justify-between text-xs text-gray-400 gap-4">
        <div>
          © {currentYear} MatiMarket. Todos los derechos reservados.
        </div>
        <div className="flex items-center gap-4 text-[11px]">
          <span className="text-gold">Edición Oro 2026</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
